import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import providerApiService from "../../services/api/ProviderApiService";
export default {
  name: "NewCoupon.vue",
  data: function data() {
    return {
      couponName: null,
      couponValue: null,
      couponType: "percentage",
      expireDate: null,
      couponId: null,
      unlimited: false
    };
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  watch: {
    coupon: function coupon(_coupon) {
      this.initialCouponValues(_coupon);
    }
  },
  mounted: function mounted() {
    if (this.coupon) {
      this.initialCouponValues(this.coupon);
    }
  },
  methods: {
    initialCouponValues: function initialCouponValues(coupon) {
      this.couponName = coupon.code;
      this.couponValue = coupon.value;
      this.couponType = coupon.percentage_based ? "percentage" : "amount";
      this.expireDate = coupon.expires_at;
      this.couponId = coupon.id;
      this.unlimited = coupon.unlimited;
    },
    resetValues: function resetValues() {
      this.couponName = null;
      this.couponValue = null;
      this.expireDate = null;
      this.couponId = null;
      this.couponType = "percentage";
      this.unlimited = false;
    },
    confirm: function confirm() {
      var _this = this;

      if (!this.validateInputs()) return;
      this.$vs.loading();
      providerApiService.createOrEditCoupon(this.currentProvider.id, {
        code: this.couponName,
        value: this.couponValue,
        percentage_based: this.couponType === "percentage" ? 1 : 0,
        expires_at: this.expireDate,
        unlimited: this.unlimited
      }, this.couponId).then(function (result) {
        if (_this.couponId) {
          /**
           * Update
           */
          _this.$emit("couponEdited", result.resource);
        } else {
          /**
           * Create
           */
          _this.$vs.notify({
            text: "کد تخفیف با موفقیت ایجاد شد.",
            color: "success",
            position: "bottom-center"
          });

          _this.$emit("couponCreated", result.resource);

          _this.resetValues();
        }
      }).catch(function (e) {
        _this.$vs.notify({
          text: e.error.response ? e.error.response.data.message : "عملیات با خطا مواجه شد",
          color: "danger",
          position: "bottom-center"
        });
      }).finally(function () {
        return _this.$vs.loading.close();
      });
    },
    validateInputs: function validateInputs() {
      if (!this.couponValue) {
        this.$vs.notify({
          text: "مقدار تخفیف اجباریست.",
          color: "warning",
          position: "bottom-center"
        });
        return false;
      }

      if (!this.couponName) {
        this.$vs.notify({
          text: "نام تخفیف اجباریست.",
          color: "warning",
          position: "bottom-center"
        });
        return false;
      }

      if (!this.expireDate) {
        this.$vs.notify({
          text: "تاریخ انقضا اجباریست.",
          color: "warning",
          position: "bottom-center"
        });
        return false;
      }

      return true;
    }
  },
  props: {
    coupon: {
      required: false,
      type: Object
    }
  }
};